module.exports = __webpack_public_path__ + "img/scatter.b66cc5ac.png";